import React, { useCallback, useEffect, useRef, useState } from 'react'
import './EditStaffInfo.css'
import { Checkbox, Col, Dropdown, Menu, Row, Table } from 'antd'
import { AlignLeftOutlined, FilterOutlined, PrinterOutlined, SearchOutlined, SettingOutlined, UploadOutlined } from '@ant-design/icons'
import { BsPencil } from 'react-icons/bs';
import images1 from '../../assets/images1.jfif'
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { BASE_URL, FetchDepartment, FetchDesignation, FetchStaff } from '../../utils/constant';
import { StopOutlined } from '@ant-design/icons';
import { ToastContainer, toast } from 'react-toastify';
import EditStaffForm from '../AllCurrentStaff/EditStaffForm';
import { useSelector } from 'react-redux';
import SearchIcon from '../../assets/icons/search-box.svg';
import FilterIcon from '../../assets/icons/filter-box.svg';
function EditStaffInfo() {
    const gridRef = useRef();
    const designationState = useSelector((state) => state.designation.designation);
    const departmentState = useSelector((state) => state.department.department);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [staffData, setStaffData] = useState([]);
    const [editItem, setEditItem] = useState(null);
    const [formVisible, setFormVisible] = useState(false);
    const [isSearchVisible, setIsSearchVisible] = useState(false);
    const [designations, setDesignations] = useState(designationState);
    const [departments, setDepartments] = useState(departmentState);
    const [selectedFilters, setSelectedFilters] = useState({
        designation: [],
        department: [],
      });
    const capitalizeFirstLetter = (str) => {
        return str?.replace(/\b\w/g, (char) => char.toUpperCase());
      };
      const toggleSearchVisibility = () => {
        setIsSearchVisible(prevState => !prevState);
      };
  
      const onFilterTextBoxChanged = useCallback(() => {
        gridRef.current.api.setGridOption(
          'quickFilterText',
          document.getElementById('filter-text-box').value
        );
      }, []);
    const gridOptions = {
        getRowClass: params => {
            if (params.node.rowIndex % 2 !== 0) {
                return 'RowColor';
            }
        },
    
    }
    const showForm = (item) => {
        setEditItem(item)
        // setFormVisible(true);
    };
    const hideForm = (item) => {
        
        setFormVisible(false);
        setEditItem(null)
        getStaffList()
    };
    useEffect(() => {
        if (editItem !== null) {
            setFormVisible(true); // Show the form when editItem changes
        }
    }, [editItem]);
    useEffect(() => {
        getStaffList();
      }, [selectedFilters]);
      const getStaffList = async () =>{
        const filtersToSend = Object.fromEntries(
            Object.entries(selectedFilters).filter(([_, value]) => value.length > 0)
        );
        const token = localStorage.getItem('authToken');
        
        try{
           
            const fetchData = async () => {
              const response = await fetch(`${BASE_URL}/${FetchStaff}`, {
                method: "POST",
                 headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                          
                        },
                body: JSON.stringify(filtersToSend),
              });
              
              if (response.ok) {
                const data = await response.json();
                const activeStaff = data.data.filter(item => item.isActive);
                console.log('activeStaff',activeStaff)
                setStaffData(activeStaff)
              
              } else {
                const data = await response.json();
                console.log('stafferr',data)
                toast.error(data.errorMessage, {
                  position: toast.POSITION.TOP_RIGHT,
                });
                
              }
            };
            await fetchData();
          } catch (error) {
            console.error('Error updating designation:', error);
        }
      }
      useEffect(() => {
        // getDepartmentList()
        // getDesignationList()
      }, []);
     
      const getDepartmentList = async () =>{
        const token = localStorage.getItem('authToken');
      
        try{
            const fetchData = async () => {
              const response = await fetch(`${BASE_URL}/${FetchDepartment}`, {
                method: "POST",
                 headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                          
                        },
                body: JSON.stringify({isDeleted:false}),
              });
              
              if (response.ok) {
                const data = await response.json();
                const activeDepartment = data?.data?.filter(item => item.isActive);
                console.log('activeDepartment',activeDepartment)
                // setFullDepartment(activeDepartment)
                const newArray = activeDepartment.map((item) => ({
                    value: item.departmentName,
                    key: item.departmentId
                  }));
                

                 setDepartments(newArray)
              } else {
                const data = await response.json();
                console.log('departmenterr',data)
               
                
              }
            };
            await fetchData();
          } catch (error) {
            console.error('Error updating designation:', error);
        }
      }
      const getDesignationList = async () =>{
        const token = localStorage.getItem('authToken');
      
        try{
            const fetchData = async () => {
              const response = await fetch(`${BASE_URL}/${FetchDesignation}`, {
                method: "POST",
                 headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                          
                        },
                body: JSON.stringify({isDeleted:false}),
              });
              
              if (response.ok) {
                const data = await response.json();
                const activeDesignation = data.data.filter(item => item.isActive);
                console.log('activeDesignation',activeDesignation)
                const newArray = activeDesignation.map((item) => ({
                    value: item.designationName,
                    key: item.designationId
                  }));
                 setDesignations(newArray)
              
              } else {
                const data = await response.json();
                console.log('departmenterr',data)
                toast.error(data.errorMessage, {
                  position: toast.POSITION.TOP_RIGHT,
                });
                
              }
            };
            await fetchData();
          } catch (error) {
            console.error('Error updating designation:', error);
        }
      }

      const filters = {
        designation: designations,
        department: departments,
      };
    
      const handleFilterMenuClick = (type, { key }) => {
        const updatedSelection = selectedFilters[type].includes(key)
          ? selectedFilters[type]?.filter((item) => item !== key)
          : [...selectedFilters[type], key];
        console.log("selectedFilters", selectedFilters);
        setSelectedFilters({ ...selectedFilters, [type]: updatedSelection });
      };
    
    const filterMenu = (type) => (
        <Menu onClick={(item) => handleFilterMenuClick(type, item)}>
          {filters[type].map((filter) => (
            <Menu.Item key={filter.key}>
              <Checkbox className='mr-1' checked={selectedFilters[type]?.includes(filter.key)}/>
                {filter.value}
            </Menu.Item>
          ))}
        </Menu>
      );
    const dropdownMenu = (
        <Menu>
          <Menu.SubMenu key="designation" title="Designation">
            {filterMenu("designation")}
          </Menu.SubMenu>
          <Menu.SubMenu key="department" title="Department">
            {filterMenu("department")}
          </Menu.SubMenu>
        </Menu>
      );

    const columnsDef = [
        {
            headerName: ' Name',
            field: 'name',
            flex: 1,
            cellRenderer: (params) => {
              return(
              <>
            <div className='flex items-center'>
              <img
                className='w-[30px] h-[30px] rounded-full !mr-3'
                src={params.data.item.faceRegisterUrl || params.data.item.logo }
                alt=''
              />
              <p>{capitalizeFirstLetter(params.data.item?.firstName)} {capitalizeFirstLetter(params.data.item?.lastName)}</p>
            </div>
            </>
              )
              },
            
          },
          {
            headerName: 'Shift',
            field: 'shift',
            flex: 1
          },
          {
            headerName: 'Location',
            field: 'location',
            flex: 1
          },
          {
            headerName: 'Gender',
            field: 'gender',
            flex: 1
          },
          {
            headerName: 'Permanent Address',
            field: 'permanentAddress',
            flex: 1
          },
          {
            headerName: 'Current Address',
            field: 'currentAddress',
            flex: 1
          },
          {
            headerName: 'Action',
            field: 'action',
          cellRenderer: (params) => {
            return (
                <>
                              {params?.data.item?.isStaffBo !== true &&

                         <div className='flex'>
                            <span className='shi-pen'>
                              <BsPencil onClick={() => showForm(params?.data?.item)}/>
                            </span>
                           
                         </div>
          }
                     </>
            );
          },
        },
      ];
      const dataDef = staffData.map((item, index) => ({

        key: index,
        item:item,
        name: `${capitalizeFirstLetter(item?.firstName)} ${capitalizeFirstLetter(item?.lastName)}`,
        shift: capitalizeFirstLetter(item?.shift?.shiftFullName),
        location: capitalizeFirstLetter(item?.mainSite[0]?.locationName1),
        gender: capitalizeFirstLetter(item?.gender),
        permanentAddress: capitalizeFirstLetter(item?.permanentAddress),
        currentAddress: capitalizeFirstLetter(item?.currentAddress),

      }));
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            flex: 1
          },
          {
            title: 'D.O.B',
            dataIndex: 'dob',
            flex: 1
          },
          {
            title: <>Perm.<br />Address</>,
            dataIndex: 'perm',
            flex: 1
          },
          {
            title: <>Current<br />Address</>,
            dataIndex: 'current',
            flex: 1
          },
          {
            title: 'Gender',
            dataIndex: 'gender',
            flex: 1
          },
          {
            title: <>Martial<br />Status</>,
            dataIndex: 'martial',
            flex: 1
          },
          {
            title: 'Action',
            dataIndex: 'action',
            flex: 1
        },
       
    ];
    const data = [];
    for (let i = 0; i < 8; i++) {
        data.push({
            key: i,
            name: <><Row>
            <Col sm={5}>
                <img className="image" style={{ width: "30px", height: "30px" }} src={images1} alt="" />

            </Col>
            <Col sm={19}>
                <p style={{ fontSize: "9px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                <p style={{ fontSize: "8px", fontWeight: "bold" }}>GM, Building Operations</p>
            </Col>
        </Row></>,
            dob: '20th June 1989',
            perm: <><p>Lorem Bhawan Lashkar</p>
            <p>Gwalior - 474001, MP Lorem</p></>,
            current: <><p>Lorem Bhawan Lashkar</p>
            <p>Gwalior - 474001, MP Lorem</p></>,
            gender: 'Male',
            martial: "Single",
            action:  <><BsPencil className='pen' /></>,
        });
    }
    const onSelectChange = (newSelectedRowKeys) => {
        console.log('selectedRowKeys changed: ', newSelectedRowKeys);
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };
    const scroll = { y: 300 };
    return (
        <div>
            <Row className='mt-3'>
                <Col sm={23}>
                    <div className='flex justify-between'>
                        {/* <PrinterOutlined className='edit-staff-icon' /> */}
                        <div className='ml-auto flex items-center gap-2'>
                        {isSearchVisible && (
                            <input
                            type="text"
                            className='border-bottom h-[36.56px] !border-[#B7D0F7] outline-none'
                            style={{width:'8rem'}}
                            id="filter-text-box"
                            placeholder="Search..."
                            onInput={onFilterTextBoxChanged}
                          />
                         )}
                            <img src={SearchIcon} onClick={toggleSearchVisibility} className='cursor-pointer'/>
                            <Dropdown
                              overlay={dropdownMenu}
                              trigger={["click"]}
                              placement="bottom"
                            >
                              <img src={FilterIcon} className='cursor-pointer'/>               
                            </Dropdown>
                            {/* <AlignLeftOutlined className='edit-staff-icon mr-1' />
                            <UploadOutlined className='edit-staff-icon mr-3' />
                            <SettingOutlined className='edit-staff-icon' /> */}
                        </div>
                    </div>
                    <div className='ag-theme-alpine text-base border-none font-proxima' style={{ height: 'auto', width: '100%', marginTop: '10px' }}>
                          <AgGridReact
                          gridOptions={gridOptions}
                            columnDefs={columnsDef}
                            rowData={dataDef}
                            domLayout='autoHeight'
                            pagination={true}
                            ref={gridRef}
                                        paginationPageSize={20}
                                        getRowHeight={() => 60}
                                        paginationPageSizeSelector={false}
                          />
                        </div>
                    {/* <div className='mt-2 info-table'>
                        <Table rowSelection={rowSelection} columns={columns} dataSource={data} pagination={false}  />
                    </div> */}
                </Col>
            </Row>
            <EditStaffForm
        open={formVisible}
        onCancel={hideForm}
        initialValue={editItem}
       />
        </div>
    )
}

export default EditStaffInfo